// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2TL_7","index":"styles_index__NjNiC"};